import { render, staticRenderFns } from "./DashboardRightAlarm.vue?vue&type=template&id=be1f8918&scoped=true&"
import script from "./DashboardRightAlarm.vue?vue&type=script&lang=js&"
export * from "./DashboardRightAlarm.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRightAlarm.vue?vue&type=style&index=0&id=be1f8918&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1f8918",
  null
  
)

export default component.exports